// ---------------------------------------------------------- ISO TILE HOVER EXPAND
// ----------------------------------------------------------
// Imposta l'altezza dell'<a> tile su hover usando la larghezza esatta + gutter.
// CSS transition: height richiede entrambi gli endpoint espliciti (non 'auto'),
// quindi setto la height corrente prima di animare verso il target.

jQuery(document).ready(function($) {

  var GUTTER = 16; // px — uguale a $grid-gutter-width SCSS, gap verticale Isotope

  $('#iso').on('mouseenter', 'article.item.sm-sq', function() {
    var a = $(this).children('a')[0];
    if (!a) return;
    var w = a.offsetWidth;
    var currentH = a.offsetHeight;
    // Freeze current height esplicita, poi anima al target nel frame successivo
    a.style.height = currentH + 'px';
    // Force reflow
    void a.offsetHeight;
    a.style.height = (2 * w + GUTTER) + 'px';
  });

  $('#iso').on('mouseleave', 'article.item.sm-sq', function() {
    var a = $(this).children('a')[0];
    if (!a) return;
    var w = a.offsetWidth;
    // Anima verso square (= width), poi rimuove l'inline al transitionend
    a.style.height = w + 'px';
    var clear = function() {
      a.style.height = '';
      a.removeEventListener('transitionend', clear);
    };
    a.addEventListener('transitionend', clear);
  });

});
